module.exports = __webpack_public_path__ + "images/help/video-files-small@2x-15ecc2528322a6596b7a5f39973b388a.png";